import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUIFormLabel(theme: Theme): Components['MuiFormLabel'] {
  return {
    styleOverrides: {
      root: {
        color: theme.palette.text.secondary,
      },
      asterisk: {
        color: theme.palette.error.main,
      },
    },
  };
}
